import { CASE_REFERENCE_PREFIX } from '@concord/config';

/** Human-quotable case reference (INT-11): "CX-2051". */
export function formatCaseReference(n: number): string {
  return `${CASE_REFERENCE_PREFIX}${n}`;
}

const REF = /^CX-(\d{1,9})$/i;

export function parseCaseReference(input: string): number | null {
  const m = REF.exec(input.trim());
  return m ? Number(m[1]) : null;
}

export function looksLikeCaseReference(input: string): boolean {
  return REF.test(input.trim());
}
